import styled from "styled-components";

export const TravelProtectionWrapper = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 1200px;
  margin: 0 auto;
  padding: 20px 30px;
`;

export const ProtectionTitle = styled.h2`
  font-size: 24px;
  margin-bottom: 24px;
  font-weight: 700;
`;

export const ProtectionPlans = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const PlanCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #d8d8d8;
  padding: 12px;
  display: flex;
  width: 100%;
  max-width: 332px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const PlanIconContainer = styled.div`
  position: relative;
  width: 51px;
  height: 51px;
  flex-shrink: 0;
  margin: 8px 12px 0px 0px;
  display: flex;
  border-radius: 16px;
  justifycontent: center;
  alignitems: center;
`;

export const PlanIcon = styled.img`
  width: 51px;
  height: 51px;
`;

export const PlanTag = styled.img`
  position: absolute;
  top: -10px;
  right: -10px;
  width: 32px;
  height: 32px;
`;

export const PlanDetails = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  h3 {
    margin: 0 0 8px;
    font-size: 18px;
  }

  p {
    margin: 0 0 12px;
    font-size: 14px;
    color: #4a4a4a;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TagImage = styled.img`
  width: 38px;
  height: 38px;
  object-fit: contain;
`;

export const TagContainer = styled.div`
  margin-left: 8px;
  display: flex;
  align-items: center;
`;

export const KnowMoreLink = styled.a`
  font-size: 14px;
  text-decoration: none;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 90%;
  max-width: 480px;
  max-height: 80vh;
  overflow-y: auto;
  padding: 24px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    width: 95%;
    padding: 16px;
  }
`;

export const ModalBody = styled.div`
  margin-bottom: 24px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ModalButton = styled.button`
  padding: 8px 24px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
`;

export const BackButton = styled(ModalButton)`
  background-color: #f2f2f2;
`;

export const NextButton = styled(ModalButton)`
  background-color: #008cff;
  color: #ffffff;
`;
